export const base_table = { page: 1, per_page: 20, order_by: "name", order_dir: "asc" };

export const base_object = {
	slug: "",
	name: "",
	estateParentID: "",
	categoriesID: "",
	implemented: false,
};
